export enum StorageKeys {
  BEARER_TOKEN = 'bearer-token',
}
